import Styled from 'styled';

import { SVGImage } from '../svg-image/svg-image';
import defaultStyles from './svg-icon.scss';

export default Styled(defaultStyles)(SVGImage);
